import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../contexts/user.context";
import { Delete, Get, handleError } from "../../../utils/fetch.util";
import LoadingData from "../../../components/loadingData/loadingData.component";
import { MainHeader } from "../sectors/sectors.styles";
import Container from "../../../components/Container/Container.component";
import BackButton from "../../../components/modals/AddAssetModal/BackButton/BackButton";
import { Link } from "react-router-dom";
import { Icon } from "../../../components/input/input.styles";
import DeleteIcon from "../../../assets/icons/delete.svg";
import { toast } from "react-toastify";
import { useCommanData } from "../../../contexts/commanData.context";

// type History = {
//   id: number;
//   channel_id: number;
//   user_id: number;
//   user_name: string;
//   device_uuid: string;
//   voice_note_url: string;
//   receive_date: Date | string;
//   createdAt: Date | string;
//   updatedAt: Date | string;
//   user: {
//     profile_pic: string;
//   };
//   location?: string;
// };

export default function DeletedSOSRequests() {
  const [history, setHistory] = useState([]);
  const [isFetching, setIsFetchingData] = useState<boolean>(true);
  const { getValidToken } = useContext(UserContext);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const { t } = useTranslation();
  const { setRecycleBin } = useCommanData();

  const deleteSosRequest = async (sos_request_id: number) => {
    const res = await Delete(
      `sos-requests/delete-sos-request-permanently?sos_request_id=${sos_request_id}`,
      getValidToken()
    );

    if (res.error && !res.data) {
      handleError(res);
      return;
    }

    toast.success("Sos Request has been deleted successfully", {
      toastId: "sos delete permanently"
    });
    setHistory(history.filter((sos: any) => sos.request_id !== sos_request_id));
  };

  useEffect(() => {
    const getAllSOSRequests = async () => {
      const res = await Get(
        `sos-requests/get-all-deleted-sos-request?page=${page}&pageItemsCount=${itemsPerPage}`,
        getValidToken()
      );
      if (res.error || !res.data) {
        handleError(res);
        setIsFetchingData(false);
        return;
      }

      setHistory(res.data.data);
      setIsFetchingData(false);
    };

    getAllSOSRequests();
  }, []);

  useEffect(() => {
    setRecycleBin("deleted-sos-requests");
  }, []);

  if (isFetching) return <LoadingData />;

  return (
    <Container className="flex flex-col gap-8">
      <BackButton />
      <MainHeader className="!my-2">
        {t("sos_history")}{" "}
        <span className="text-2xl">({history.length || 0})</span>
      </MainHeader>

      {history.length > 0 && (
        <div className="overflow-x-auto w-full">
          <table>
            <thead>
              <th className="border-2 p-4 py-2 min-w-[150px]">
                {t("location")}
              </th>
              <th className="border-2 p-4 py-2 min-w-[150px]">{t("Date")}</th>
              <th className="border-2 p-4 py-2 min-w-[150px]">{t("action")}</th>
            </thead>
            <tbody>
              <tr className="h-6">
                <td></td>
              </tr>
              {history.map((sos: any) => {
                const date = new Date(sos.createdAt);
                const day = date.getUTCDate().toString().padStart(2, "0");
                const month = (date.getUTCMonth() + 1)
                  .toString()
                  .padStart(2, "0");
                const year = date.getUTCFullYear().toString().padStart(2, "0");
                const hours = date.getUTCHours().toString().padStart(2, "0");
                const minutes = date
                  .getUTCMinutes()
                  .toString()
                  .padStart(2, "0");

                return (
                  <tr key={sos.request_id}>
                    <td className="border-2 p-4 py-2">
                      <Link className="text-blue-500" to={sos.location}>
                        {sos.location}
                      </Link>
                    </td>
                    <td className="border-2 p-4 py-2">
                      {year}-{month}-{day} / {hours}:{minutes}
                    </td>
                    <td className="border-2 p-4 py-2">
                      <button>
                        <Icon
                          src={DeleteIcon}
                          onClick={() => deleteSosRequest(sos.request_id)}
                          style={{ width: 20, height: 20 }}
                          className="inline-block !m-0"
                        />
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </Container>
  );
}
